<template>
  <div class="table-container">
    <table style="width:90%" class="styled-table">
      <tbody>
        <tr>
          <td>
            <!-- Mostrar título de la sección -->
            <span class="titulo-seccion">{{ section.titulo }}</span>
              <ul>
                <li v-for="(archivo, i) in section.contenido" :key="i">
                  <div class="contenido-fila">
                    <!-- Enlaces según el tipo de archivo -->
                      <a v-if="archivo.url_pdf" :href="urlServe + archivo.url_pdf" target="_blank" class="file-link">
                        {{ archivo.titulo || "Descargar documento" }}
                      </a>
                      <a v-if="archivo.url_word" :href="urlServe + archivo.url_word" target="_blank" class="file-link">
                        {{ archivo.titulo || "Descargar documento" }}
                      </a>
                      <a v-if="archivo.url_excel" :href="urlServe + archivo.url_excel" target="_blank" class="file-link">
                        {{ archivo.titulo || "Descargar documento" }}
                      </a>
                      <a v-if="archivo.url_comprimido" :href="urlServe + archivo.url_comprimido" target="_blank" class="file-link">
                        {{ archivo.titulo || "Descargar documento" }}
                      </a>
                      <a v-if="archivo.link" :href="archivo.link" target="_blank" class="file-link">
                        {{ archivo.titulo || "Descargar documento" }}
                      </a>
                  </div>
                </li>
              </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    urlServe: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
/* Contenedor general de la tabla */
.table-container {
  border-bottom: 1px solid #cfcfcf;
  padding: 20px;
}

/* Estilo para el título de la sección */
.titulo-seccion {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
}

/* Lista de archivos */
ul {
  list-style: none;
  padding: 0;
  margin-top: 10px;
  padding-left: 1rem;
}

/* Estilo para cada archivo (fila) */
li {
  margin: 10px 0;
  border-bottom: 1px dotted rgb(189, 182, 182);
  transition: transform 0.2s ease;
}
li:hover {
  transform: scale(1.01);
}

/* Contenido de cada fila (enlaces) */
.contenido-fila {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

/* Estilo para los enlaces de los archivos */
.file-link {
  font-size: 14px;
  /* font-weight: 500; */
  color: #2e2e2e;
  text-decoration: none;
  transition: color 0.3s ease, text-decoration 0.3s ease;
}
.file-link:hover {
  color: #801a42;
}
</style>

